<template>
  <div class="mobile">
    <div :class="'select ' + status">
      <div v-for="(item, index) in routerList" :key="index" @click="toRouter(index)" class="option">{{item.tit}}</div>
    </div>
    <div :style="'height:' + (status === 'close' ? innerHeight : '0px')" class="bgcover">
    </div>
    <div class="header">
      <img src="../assets/logo1.png" alt="">
      <div @click="change" :class="'menu ' + status">
      </div>
    </div>
    <div id="pc_top" class="mobile_top">
      <div class="mobile_top_black">
        <img src="../assets/black.png" alt="">
      </div>
      <div class="mobile_top_Copywriting">
        <p><span>小品出行</span></p>
        <p><span>中国互联网出行助力车平台</span></p>
      </div>
    </div>
    <div id="xpadVantage" class="xpadVantage">
      <div class="advantage_tit">
        <div>
          <p><span>为什么要选择小品?</span></p>
          <p><span>小品助力，坐享骑程</span></p>
        </div>
      </div>
      <div class="advantageItem">
        <div class="title">
          <img class="pollution_reduction" src="../assets/pollution_reduction.png" alt="">
          <span>减少环境污染</span>
        </div>
        <div class="advcont">
          <span>小品出行公共电助车采用超威环保锂电池作为主要动力源，可以做到零排放，小品出行采取统一采购、统一回收、统一处理。有效避免电池随意丢弃处置造成的环境污染</span>
        </div>
      </div>
      <div class="advantageItem">
        <div class="title">
          <img class="traffic_safety" src="../assets/traffic_safety.png" alt="">
          <span>增加交通安全</span>
        </div>
        <div class="advcont">
          <span>小品出行每一辆公共电助车均符合2019年4月15日最新颁布的《电动自行车安全技术规范》，通过国家3C认证，并且进入浙江省电动车目录。小品出行公共电助车与国内知名保险集团中国人寿合作，为小品出行公共电助车进行投保，保险涵盖意外险、医疗险。</span>
        </div>
      </div>
      <div class="advantageItem">
        <div class="title">
          <img class="battery_management" src="../assets/battery_management.png" alt="">
          <span>电池管理安全</span>
        </div>
        <div class="advcont">
          <span>小品出行公共电助车的电池充电管理是科学的且符合规范的，首先，我们会在长兴建设专业的充电场所作为电池充电存放，电池充电存放场所全权委托超威集团建设提供技术规范和安全规范，使充放场所完全合规。</span>
        </div>
      </div>
      <div class="advantageItem">
        <div class="title">
          <span>减少交通压力</span>
        </div>
        <div class="advcont">
          <span>小品出行为每一辆电助车配备了GPS定位系统，并与城市公共自行车服务站相结合。定位范围覆盖全市，精准度在100%，通过结合长兴县目前为公共自行车提供技术的江苏宏博科技有限公司的定点技术可以做到首尾一致。随着小品出行公共电助车的投放，市民必然对自己的出行方式进行调整，小品出行公共电助车因为其体型小巧，不会占用过多的停放面积。</span>
        </div>
        <img class="traffic_pressure" src="../assets/traffic_pressure.png" alt="">
      </div>
    </div>
    <div id="xpFocus" class="xpTraffic">
      <div class="trafficTitle">
        <p><span>关于我们</span></p>
        <p><span>小品电助车优势</span></p>
      </div>
      <div class="trafficItem">
        <img class="focusUnion" src="../assets/focusUnion.png" alt="">
        <div class="trafficItemTit">
          <p><span>强强联合 </span></p>
          <p><span>与超威联手</span></p>
        </div>
        <div class="trafficItemCont">
          <span>小品出行公共电助车与浙江超威集团签订战略合作协议，双方在电池采购、电池管理、电池回收上达成共识，并积极探索业务合作新模式。</span>
        </div>
      </div>
      <div class="trafficItem">
        <img class="focusUnion" src="../assets/newPattern.png" alt="">
        <div class="trafficItemTit">
          <p><span>停车新模式</span></p>
          <p><span>全新自行车管理系统</span></p>
        </div>
        <div class="trafficItemCont">
          <span>小品出行公共电助车全部接入政府主导的公共自行车管理系统，实行同站点分区停放。便于政府集中管理并监控。</span>
        </div>
      </div>

      <div class="trafficItem">
        <img class="focusUnion" src="../assets/deposit_management.png" alt="">
        <div class="trafficItemTit">
          <p><span>免押出行</span></p>
          <p><span>实名认证享无忧出行</span></p>
        </div>
        <div class="trafficItemCont">
          <span>小品出行对所有新注册的用户采取免押金的政策，扫码出行，资金安全有保障，尊享极致体验。</span>
        </div>
      </div>
    </div>
    <div class="footer">
      <div class="footer_top">
      </div>
      <div class="footer_bottem">
        <p><img src="../assets/logo1.png" alt=""></p>
        <div class="footer_detail">
          <p>400 105 6680</p>
          <p>浙江省湖州市吴兴区区府路1188号总部自由港H幢16楼</p>
          <p>浙江本源质品信息科技股份有限公司</p>
          <p @click="toR('https://beian.miit.gov.cn/')">浙ICP备19007528号-1</p>
        </div>
      </div>
    </div>
    <div class="downLoad">
      <img src="../assets/logo1.png" alt="">
      <div class="downLoadBtn" @click="downLoad"><span>立即下载</span></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Mobile',
  mounted () {
    if (!(navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {
      this.$router.push({path: '/pc'})
    }
    const that = this
    window.addEventListener(
      'resize',
      function () {
        that.screenHeight = window.innerHeight
        that.setSize()
      },
      false
    )
    if (document.createEvent) {
      var event = document.createEvent('HTMLEvents')
      event.initEvent('resize', true, true)
      window.dispatchEvent(event)
    } else if (document.createEventObject) {
      window.fireEvent('onresize')
    }
    this.handleScroll()
    window.addEventListener('scroll', this.handleScroll, true)
  },
  data () {
    return {
      status: 'open',
      routerList: [
        {tit: '首页', active: true, url: 'pc_top'},
        {tit: '小品出行', active: false, url: 'xpadVantage'},
        {tit: '关于我们', active: false, url: 'xpFocus'}
      ],
      innerHeight: '0px'
    }
  },
  methods: {
    handleScroll (e) {
      // var scrollTop = document.documentElement.scrollTop || document.body.scrollTop
    },
    setSize: function () {
      this.innerHeight = window.innerHeight + 'px'
      document.documentElement.style.fontSize = ((window.innerWidth / 750) * 100) + 'px'
    },
    toR (url) {
      window.location.href = url
    },
    toRouter (i) {
      document.getElementById(this.routerList[i].url).scrollIntoView({'behavior': 'smooth'})
      this.change()
    },
    change () {
      this.status === 'open' ? this.status = 'close' : this.status = 'open'
    },
    downLoad () {
      window.location.href = 'http://h5s.pin-bike.com/down.html'
    }
  }
}
</script>
<style scoped>
.mobile{
  padding:1rem 0;
}
.mobile *{
  box-sizing: border-box;
}
p{
  margin:0;
}
.bgcover{
  width: 100%;
  background-color: rgba(0, 0, 0, 0.1);
  z-index: 99;
  position: fixed;
  top: 0;
}
.select {
  width: 100%;
  padding: 0 0.36rem;
  height: 3.04rem;
  text-align: left;
  background-color: #fff;
  color: #666666;
  font-size: 0.34rem;
  position: fixed;
  top:1rem;
  z-index: 100;
  overflow: hidden;
  transition: all .5s;
  -moz-transition: all .5s;
  -webkit-transition: all .5s;
  -o-transition: all .5s;
}
.select.open{
  top:-5rem;
  transition: all .5s;
  -moz-transition: all .5s;
  -webkit-transition: all .5s;
  -o-transition: all .5s;
}
.select.close{
  top:1rem;
  opacity: 0.89;
  transition: all .5s;
  -moz-transition: all .5s;
  -webkit-transition: all .5s;
  -o-transition: all .5s;
}
.select .option{
  height: 1rem;
  line-height: 1rem;
  border-bottom: 1px solid #E5E5E5;
}
.select .option:last-of-type{
  border:none;
}
.header{
  width: 100%;
  height: 1rem;
  padding:0.2rem 0.32rem;
  background-color: #F8F8F8;
  z-index: 1000;
  position: fixed;
  top: 0;
}
.header>img{
  width: 2.16rem;
  height: 0.6rem;
  float: left;
}
.header .menu {
  width: 0.6rem;
  height: 0.6rem;
  float: right;
}
.header .menu.open{
  background-image: url('../assets/mobileClose.png');
  background-repeat: no-repeat;
  background-size: 0.34rem 0.29rem;
  background-position: center center;
}
.header .menu.close{
  background-image: url('../assets/mobileOpen.png');
  background-repeat: no-repeat;
  background-size: 0.29rem 0.29rem;
  background-position: center center;
}
.mobile_top{
  height: 3.88rem;
  background-image: url('../assets/banner.png');
  background-repeat: no-repeat;
  background-size: 100%, auto;
  position: relative;
}
.mobile_top .mobile_top_black{
  width: 3.2rem;
  height: 2.9rem;
  position: absolute;
  top:0.98rem;
  right:0.32rem;
}
.mobile_top .mobile_top_black>img{
  width: 100%;
  height: 100%;
}
.mobile_top .mobile_top_Copywriting{
  position: absolute;
  top:1.08rem;
  left: 0.58rem;
  color: #fff;
  text-align: left;
}
.mobile_top .mobile_top_Copywriting>p:nth-of-type(1){
  font-size: 0.48rem;
  line-height: 0.78rem;
  font-weight: 500;
}
.mobile_top .mobile_top_Copywriting>p:nth-of-type(2){
  font-size: 0.28rem;
  line-height: 0.78rem;
}
.xpadVantage .advantage_tit{
  width: 100%;
  height: 2.3rem;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family:'PingFangSC-Semibold';
}
.xpadVantage .advantage_tit p:nth-of-type(1){
  color: #7E8085;
  font-size: 0.24rem;
  line-height: 0.33rem;
  font-weight:600;
  margin:0.11rem 0;
}
.xpadVantage .advantage_tit p:nth-of-type(2){
  color: #2C2E30;
  font-size: 0.4rem;
  line-height: 0.46rem;
  font-weight:600;
}
.xpadVantage .advantageItem{
  width: 6.66rem;
  color: #666666;
  box-shadow:0px 0.02rem 0.1rem 0px rgba(0,0,0,0.14);
  border-radius:0.05rem;
  padding:0.42rem;
  margin: 0 auto 0.6rem auto;
  font-size: 0.28rem;
  font-weight:400;
}
.xpadVantage .advantageItem .title{
  height: 0.48rem;
  font-size: 0.34rem;
  color: #2C2E30;
  font-family:'PingFangSC-Semibold';
  font-weight:600;
}
.xpadVantage .advantageItem .title img{
  line-height: 0.48rem;
  vertical-align:middle;
  margin-right: 0.1rem;
}
.xpadVantage .advantageItem .pollution_reduction{
  width: 0.48rem;
  height: 0.48rem;
}
.xpadVantage .advantageItem .traffic_safety{
  width: 0.4rem;
  height: 0.4rem;
}
.xpadVantage .advantageItem .battery_management{
  width: 0.36rem;
  height: 0.2rem;
}
.xpadVantage .advantageItem .traffic_pressure{
  width: 5.82rem;
  height: 4.1rem;
  margin-top: 0.3rem;
}
.xpadVantage .advantageItem .advcont{
  margin-top: 0.32rem;
}
.xpTraffic .trafficTitle>p:nth-of-type(1){
  color: #7E8085;
  font-size:0.24rem;
  font-family:'PingFangSC-Regular';
  font-weight:400;
  line-height:0.33rem;
}
.xpTraffic .trafficTitle>p:nth-of-type(2){
  color: #2C2E30;
  font-size:0.4rem;
  font-family:'PingFangSC-Regular';
  font-weight:600;
  line-height:0.46rem;
  margin-bottom: 0.26rem;
}
.xpTraffic .trafficItem{
  width: 6.66rem;
  color: #666666;
  box-shadow:0px 0.02rem 0.1rem 0px rgba(0,0,0,0.14);
  border-radius:0.05rem;
  padding:0.42rem;
  margin: 0 auto 0.6rem auto;
  font-size: 0.28rem;
  font-weight:400;
}
.xpTraffic .trafficItem .trafficItemTit{
  margin: 0.36rem 0;
}
.trafficItem .trafficItemTit p:nth-of-type(1){
  color: #2C2E30;
  font-size: 0.34rem;
  line-height: 0.48rem;
  font-weight: 600;
}
.trafficItem .trafficItemTit p:nth-of-type(2){
  color: #2F5BEA;
  font-size: 0.34rem;
  line-height: 0.48rem;
  font-weight: 600;
}
.trafficItem .trafficItemCont{
  color: #666666;
  font-size:0.28rem;
  font-family:'PingFangSC-Regular';
  font-weight:400;
  line-height:0.5rem;
}
.trafficItem .focusUnion{
  width: 1.08rem;
  height: 1.08rem;
}

.footer .footer_top{
  height: 1.09rem;
  background-image: url('../assets/xpzlBg.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
  position: relative;
  font-size:0.72rem;
  font-family:'PingFangSC-Semibold';
  font-weight:600;
  color:rgba(255,255,255,1);
  line-height:1rem;
}
.footer .footer_top>div{
  position: absolute;
  left: 50%;
  top: 50%;
  -webkit-transform: translate(-50%,-50%);
  -ms-transform: translate(-50%,-50%);
  transform: translate(-50%,-50%);
}
.footer .footer_top p:nth-of-type(2){
  font-size:0.56rem;
  font-family:'HelveticaNeue-Medium';
  font-weight:500;
  color:rgba(255,255,255,1);
  line-height:0.69rem;
  margin-top: 0.3rem;
}
.footer .footer_bottem{
  height: 2.8rem;
  padding:0.2rem 0;
  position: relative;
}
.footer .footer_bottem>p:nth-of-type(1) img{
  width: 2.009rem;
  height: 0.567rem;
}
.footer .footer_detail{
  font-size:0.16rem;
  font-family:'PingFangSC-Regular';
  font-weight:400;
  line-height:0.25rem;
  color: #666666;
}
.footer .footer_detail p{
  margin: 0.08rem 0;
}
.footer .footer_detail p:hover{
  cursor: pointer;
  opacity: 0.8;
}
.downLoad{
  width: 100%;
  height: 1rem;
  background-color: #F8F8F8;
  position: fixed;
  bottom: 0rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding:0 0.32rem;
}
.downLoad>img{
  width: 2.16rem;
  height: 0.61rem;
}
.downLoad .downLoadBtn{
  width:1.46rem;
  height:0.54rem;
  line-height: 0.54rem;
  text-align: center;
  border-radius:0.04rem;
  background-color: #42C75E;
  font-size:0.2rem;
  font-family:'PingFangSC-Regular';
  font-weight:400;
  color:rgba(255,255,255,1);
}
</style>



// WEBPACK FOOTER //
// src/components/Mobile.vue